<template>
  <div style="height: 100%">
    <GmapMap
      v-if="apl.center"
      :center="center"
      :zoom="zoom"
      map-type-id="roadmap"
      style="width: 100%; height: 100%"
      :options="{ styles: mapStyles }"
      @click="infoClosed"
      ref="map">
      <gmap-cluster :max-zoom="cluster ? 16 : 1" :ignore-hidden="true">
        <template v-for="marker in markers">
          <GmapMarker
            :key="marker._id + 'marker'"
            :position="{ lat: marker.lat, lng: marker.lng }"
            :animation="search && search._id === marker._id ? 1 : 0"
            :visible="(filters.includes(`${marker.category} - ${marker.status}`) || marker.status_id === null) && ((categorii.includes(marker.category) || marker.category_id === null))"
            :clickable="true"
            @click="markerClicked(marker)"
            :icon="{
              url: getIcon(marker.status_id ? marker.status_id.icon : null),
              scaledSize: {
                width: 36 * (marker.status_id ? marker.status_id.icon.scale : 2),
                height: 64 * (marker.status_id ? marker.status_id.icon.scale : 2)
              },
              origin: { x: 0, y: 0 },
              anchor: {
                x: 36 * (marker.status_id ? marker.status_id.icon.scale : 2) / 2,
                y: 64 * (marker.status_id ? marker.status_id.icon.scale : 2)
              }
            }"
          />
        </template>
      </gmap-cluster>
      <GmapPolygon :paths="decodePath(apl)" :options="polyOptions(apl)" v-if="poly" @click="infoClosed" />
      <gmap-info-window
        :position="infoPosition"
        :opened="infoOpen"
        @closeclick="infoClosed"
        :options="{
          pixelOffset: {
            width: 0,
            height: selectedMarker ? -1 * 60 * (selectedMarker.status_id ? selectedMarker.status_id.icon.scale : 2) : -35
          }
        }">
        <v-card v-if="selectedMarker" class="ma-0" outlined style="overscroll-behavior: contain">
          <v-list-item class="px-0">
            <v-list-item-avatar height="64">
              <v-img :src="getIcon(selectedMarker.status_id ? selectedMarker.status_id.icon : null)" contain></v-img>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="subtitle-2" style="overflow: visible; white-space: normal">
                {{ corpuri[0]['Unitatea de invatamant'] }} - {{ selectedMarker.address }}
              </v-list-item-title>
              <v-list-item-subtitle style="overflow: visible; white-space: normal">
                {{ selectedMarker.category_id ? selectedMarker.category_id.name : selectedMarker.category }}
                -
                {{ selectedMarker.status_id ? selectedMarker.status_id.name : selectedMarker.status }}
              </v-list-item-subtitle>
              <v-list-item-subtitle>
                <template v-if="selectedMarker.program">
                  Program: {{ selectedMarker.program }}
                </template>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-card-text class="px-0">
            <!-- <v-skeleton-loader
              :loading="!detailsLoaded"
              transition="scale"
              class="mx-auto"
              type="card">
              <v-card>marker info</v-card>
            </v-skeleton-loader> -->
              <v-tabs>
                <v-tab v-for="(corp, index) in corpuri" :key="index">
                  {{ corp.Corp }}
                </v-tab>
                <v-tab-item v-for="(corp, index) in corpuri" :key="index">
                  <v-expansion-panels multiple accordion :value="[0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15]">
                    <template v-if="corp.poze">
                      <v-carousel
                        cycle
                        :height="$vuetify.breakpoint.name === 'xs' ? '20vh' : '50vh'"
                        hide-delimiter-background
                        progress
                        progress-color="secondary"
                        show-arrows-on-hover>
                        <v-carousel-item v-for="picNo in corp.poze" :key="picNo">
                          <v-img
                            :lazy-src="getPicURL(corp, index, picNo, true)"
                            :src="getPicURL(corp, index, picNo)"
                            contain
                            height="100%">
                            <template v-slot:placeholder>
                              <v-row class="fill-height ma-0" align="center" justify="center">
                                <v-progress-circular indeterminate color="primary"></v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>
                          <!-- <v-img :src="img.src" height="100%">
                            <template v-slot:placeholder>
                              <v-col cols="12" class="fill-height align-center justify-center ma-0">
                                <v-progress-circular indeterminate color="red lighten-2" />
                              </v-col>
                            </template>
                          </v-img> -->
                        </v-carousel-item>
                      </v-carousel>
                    </template>
                    <template v-for="h in corpuriH">
                      <v-expansion-panel :key="h + index" v-if="corp[h] !== null">
                        <v-expansion-panel-header hide-actions>
                          <div class="subtitle-2">{{ h }}</div>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <div v-if="h === 'Etapele procesului de reabilitare'" v-html="corp[h]"></div>
                          <div class="body-2" v-else-if="h.includes('energie')">{{ Math.round(corp[h] * 100 * 100) / 100 }}%</div>
                          <div class="body-2" v-else>{{ corp[h] }}</div>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </template>
                  </v-expansion-panels>
                </v-tab-item>
              </v-tabs>
          </v-card-text>
        </v-card>
      </gmap-info-window>
    </GmapMap>
    <v-sheet color="white" elevation="1" max-height="80vh" max-width="50vw" style="position: fixed; top: 120px; left: 12px; overflow-y: auto; overflow-x: hidden">
      <!-- <v-card flat> -->
        <v-card-title class="py-1 px-0">
          <span v-if="apl" style="padding-left: 8px; max-width: calc(100% - 24px - 28px - 8px - 4px); white-space: nowrap" class="subtitle-2">{{ apl.name }}, {{ apl.county }}</span>
          <v-spacer>
          </v-spacer>
          <v-btn icon @click="toggleMinimize" small>
            <v-icon small>{{ minimized ? 'mdi-window-maximize' : 'mdi-window-minimize' }}</v-icon>
          </v-btn>
          <!-- <v-btn icon @click="toggleFullscreen" small>
            <v-icon small>{{ fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}</v-icon>
          </v-btn> -->
        </v-card-title>
        <v-card-text v-show="!minimized" style="overscroll-behavior: contain">
          <v-list dense subheader>
            <v-subheader>Categorii</v-subheader>
            <v-list-item v-for="categorie in categories" :key="categorie._id">
              <v-list-item-icon>
                <v-img
                  :src="getIcon(categorie.icon)"
                  lazy-src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADoAAAA8CAYAAAA34qk1AAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAABvpJREFUeJzNm3lsFFUcgGk5yiVdSkHlCEVAbkGDRyISjXIokSMEPEA5REQxIooma0NQrGIoBiVexPgHChiCIphQUMQoaGUhHI0BkUNAwilIodgWKMXvx77VYZk38+bt0PJLvjQtM+/9vp1371CjRhVGLLa+HtwCUfgKYvATLITnoTtkVmVOoQbJ14TblVQZXNBQDjsgHzpCWnXnbhwk2wCmwt8egm6chMXQq7odfIMk68BLUBpQ0skRmAmR6vbRBsn1heMpSCaohGXQtVqFonlv13X7u0ouVUmn7Ga4t6r9RLALzIKhLpKtfQYeW3bDoKoS7ABvw3Z4Axq4iEYDJH8W9sEmKIID6gnqrt8LA6+kYCZMg1NQCs/oriWR7w2a4jp4ArJc7m8CY2AplLjc/xd0vxKSHWEzXFCSYyDdQ/SAh6QkPglqmdTNdfXhVdjv0oxbhCWYDg/DSSV5Bib4SGZ4ND2ZT3vb5MJ9jWFGLD7HJspbLR+EvWGNi5IZ8CZUKMlK1XQ9nwQVt9FIloXRtyijB/ziKPe1mO0qCpnGMF8JJpgL9QwS6aoRnW2d0OV1yLp5FlSoD/CuwIUgkwWLkyQPQ2vDJDq4SB6TJx04Ge96ZA09IRZfIxdI0za+GZlGMC9JUprsuAAJRFxEZRTW9mvbkBYCD8FpGG10EzK1IS9JUtgCDQMmUJwk+paNSID6JsMauN73YmTGq1HVKSm/P2hRcaFDUvrRWCsD8/rSVTPu63khMs1gj8vT3CoLBYuK5zhEpVkNtrYIVq/33IzM+y6SQp5lhXc75lJpxv2tMg8zkGkLJS6S5XCrTZlqRNzvEO0Xdt6BA5mPNE/zT2nStuUi96Gj6VbNjkMXiNSHoxpRGW1r25aNXB/4B87BqDDyzcldnQERaArZkAn+OSIySiMprEklKbV6maee6is2ZSBRHzrDJFgCm2A77IZd8BtsgE9gKDSHy+drlxWQk59TEVWyveEUfBxQsBk8BxuhGM4acAb2QR5cOp+qzbNO9Neo5pgkgKgckL0LP5qsc0kwC6bAH4ZyOuQDausUPe0hegRapSKqZOWMdlXMZYPtEKwNg1WzTEXQyU5olRCt9BCVf3syBFFZjw6BmzWSXWABlCY1w8OqL4r8ISi3kF0Hdf2eqFAkW7YQZOUgu2eSYLoaQLbAXlgEuTAM7oBO0A7aQEforfrtcigJ0G8n+vVRQTbdr0PNEGT/mwZUUx0LM+FRJWV0UsB1jVUzLzKU3Syin/qICnIY9lQYso5kM9XTshrsuC9NPeUCA9EyEe0F5w1k5cxoCjQKSzaMQKK16oeesonDr5UGoonTv29gJGSbJMJ1adAUekYNjmEsZXvBMU9RlUyWWteayDr3qYWQDxNhBAyHR6Lxfe10WAI7oQC6OZOLrHiveciyi3xFlWx7C1k/1sMAt8QQvR9uCFF0hNdIfMnFJNVOffomfdaLmHqy2pUQku0hD+qEJCoD2w4jUSUrffYeWAonAshJa/gAjL7aQ7AhFEEoG3JkankMSmWeN5N0Heih+p/0OTkd/BIWReMnEpOhH1j1NyQLoBCutbJLCoS+1YiuD6N860BwDlyACWGUh9BqjWh+GOVbB4IvK9GNqY7COfEN+QbNEvDGsHK2CuTGwnkl+1gqZSHTVjMYpXR4EEogNwxKleiKVMpCaBCcSJKU3VDVvwqQHMgNgdNKVH5q96t+gdB0l6e5PMx8rQOx4VCmRIXHbcpRU8t3SZKyJOzmeSMV3gShfvOlqWeco48KC2zKUf3zkENSNugzTBLoA8sgx6Zi06D8aQ5JYUvQMtR2LTfpaa4C/6/81aplPnwNRruUoEG5abA4SbQ4aDk58ePNXQ7JbWD+7QKV9oQj8AO0DJqAQfnZsCdJVLjsVR5d5MSPYmY7JPfIli1oIjUhFyqlSUm/DWzjXf7opP6ZwHg5iNRtcFxJHoD+0pRtkrkOtqsEDsIAMHplxqfcFrDLRVJoalJGTvwoplBJiuyAHLcT+gBJ3QclKgn5OQv8v1XWlyf9f4lGUp6w7/coajp5QY2uB2FgSpIqsXQY75jvpCnvVnvJ9gHL6gQrNU32YqvxK0P1yxFqnpTdSg+r5qpJMANmQIUjqQrV/N6B/qA9NJMWAM/C7+qDcpMU1vpIylTSF7bCXBlxQxFMSvYa+ELzNIoj8U30Z2punAhPw1Q1TW2Fcg/BBLN9RGVhsBBGQqCXR4LKtoKlHk0vVe70Ec1Wslf+XXuSaQmfw7mQJbdFQhjRQ41IfLLPj/y/80gV6bcvVreXNkjuATgagqhMN1fvfw6QIMEmsCBy6YgcBDkcM3rH8KoIku0MK+CsoaAMaAsjIZ0AVnmQePNIfFpZq+nD8rdVMBBCfwlSF/8C3QjwwqUt65wAAAAASUVORK5CYII="
                  width="24"
                  contain>
                </v-img>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title :title="categorie.name">
                  {{ categorie.name }}
                </v-list-item-title>
                <v-list-item-subtitle>
                  {{ numbersCategories[categorie.value] }}
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-switch dense :color="categorie.color" v-model="categorii" :value="categorie.value"></v-switch>
              </v-list-item-action>
            </v-list-item>
            <v-subheader>Filtre</v-subheader>
            <v-list-item v-for="status in statusesForSelectedCategories" :key="status._id">
              <v-list-item-icon>
                <v-img
                  :src="getIcon(status.icon)"
                  lazy-src="data:image/png;base64,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"
                  width="24"
                  contain>
                </v-img>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title :title="`${status.category_id.name} - ${status.name}`">
                  <!-- {{ status.category_id.name }} - {{ status.name }} -->
                  {{ status.name }}
                </v-list-item-title>
                <v-list-item-subtitle>
                  {{ numbersFilters[status.category_id.value][status.value] }}
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-switch dense :color="status.color" v-model="filters" :value="`${status.category_id.value} - ${status.value}`"></v-switch>
              </v-list-item-action>
            </v-list-item>
            <v-subheader>Optiuni</v-subheader>
            <v-list-item>
              <v-list-item-icon>
                <v-icon :color="apl && apl.borders ? apl.borders.stroke : 'primary'">mdi-vector-polygon</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>PERMIETRU</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-switch dense v-model="poly" :color="apl && apl.borders ? apl.borders.stroke : 'primary'"></v-switch>
              </v-list-item-action>
            </v-list-item>
            <v-list-item>
              <v-list-item-icon>
                <v-icon color="accent">mdi-circle-multiple-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>GRUPARE</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-switch dense v-model="cluster" color="accent"></v-switch>
              </v-list-item-action>
            </v-list-item>
            <v-subheader>Cautare</v-subheader>
            <v-list-item>
              <v-list-item-icon>
                <v-icon color="accent">mdi-map-search</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-autocomplete
                  dense
                  single-line
                  return-object
                  v-model="search"
                  :filter="itemFilter"
                  :items="markers"
                  label="Cautare adresa"
                  clearable
                  item-text="name"
                  item-value="name">
                  <template v-slot:item="data">
                    <v-list-item-avatar>
                      <v-img
                        :src="getIcon(data.item.status_id ? data.item.status_id.icon : null)"
                        lazy-src="data:image/png;base64,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"
                        width="24"
                        contain>
                      </v-img>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title v-html="data.item.name"></v-list-item-title>
                      <v-list-item-subtitle v-html="data.item.address"></v-list-item-subtitle>
                      <v-list-item-subtitle v-html="data.item.status"></v-list-item-subtitle>
                    </v-list-item-content>
                  </template>
                </v-autocomplete>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card-text>
        <!-- <v-card-actions v-show="!minimized" style="padding-left: 24px; padding-right: 24px">
          <div style="width: 100%">
            <v-list dense subheader>
              <v-subheader>Inaltime</v-subheader>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon :size="24" :color="apl && apl.borders ? apl.borders.fill : 'accent'">mdi-arrow-expand-vertical</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-slider
                    v-model="sheetHeight"
                    :color="apl && apl.borders ? apl.borders.fill : 'accent'"
                    track-color="grey"
                    hide-details
                    :min="15"
                    :max="80">
                  </v-slider>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </div>
        </v-card-actions> -->
      <!-- </v-card> -->
    </v-sheet>
  </div>
</template>

<script>
import SERVER_URL from '@/config'
import { gmapApi } from 'vue2-google-maps'
import mapStyles from '@/mapStyles.json'

export default {
  name: 'avz-apl-map',

  props: {
    aplid: {
      type: String,
      required: true
    }
  },

  data: () => ({
    sheetHeight: 20,
    minimized: false,
    fullscreen: false,
    search: null,
    options: true,
    poly: true,
    cluster: false,
    apl: {},
    markers: [],
    statuses: [],
    categories: [],

    categorii: [],
    filters: [],
    numbersFilters: {},
    numbersCategories: {},
    mapStyles,
    center: null,
    zoom: 12,
    infoPosition: { lat: 0, lng: 0 },
    infoOpen: false,
    selectedMarker: null,

    detailsLoaded: false,

    corpuri: null,
    corpuriH: [
      'Status', 'Unitatea de invatamant', 'Adresa obiectiv', 'Tip unitate', 'Corp', 'An constr.', 'Regim inaltime', 'Nr. Sali de clasa', 'Economie de energie primara', 'Procent energie din surse regenerabile', 'Etapele procesului de reabilitare'
    ]
  }),

  watch: {
    search (value) {
      if (value) {
        this.minimized = true
        this.center = { lat: value.lat, lng: value.lng }
        this.zoom = 20
      } else {
        this.center = this.apl.center
        this.zoom = 12
      }
    }
  },

  computed: {
    google: gmapApi,
    decodePath () {
      return apl => {
        if (this.google && apl.borders) {
          const poly = this.google.maps.geometry.encoding.decodePath(apl.borders.polyString)

          return poly
        } else {
          return []
        }
      }
    },
    polyOptions () {
      return apl => ({
        fillColor: apl && apl.borders ? apl.borders.fill : 'blue',
        strokeColor: apl && apl.borders ? apl.borders.stroke : 'blue'
      })
    },

    statusesForSelectedCategories () {
      return this.statuses.filter(status => this.categorii.includes(status.category_id.value))
    }
  },

  methods: {
    itemFilter (item, queryText, itemText) {
      const textOne = item.name.toLowerCase()
      const textTwo = item.address.toLowerCase()
      const searchText = queryText.toLowerCase()

      return textOne.indexOf(searchText) > -1 ||
        textTwo.indexOf(searchText) > -1
    },
    toggleMinimize () {
      this.fullscreen = false
      this.minimized = !this.minimized
    },
    toggleFullscreen () {
      this.minimized = false
      this.fullscreen = !this.fullscreen
    },
    async getAPL () {
      const apl = await this.$store.dispatch('getAPL', this.aplid)
      this.apl = Object.freeze(apl)
      this.center = apl.center

      this.$store.commit('setCurrentAPL', apl)
    },
    async fetchMarkers () {
      const markers = await this.$store.dispatch('fetchAllMarkers', { apl_id: this.aplid })
      this.markers = Object.freeze([...markers])
      markers.forEach(marker => {
        if (this.numbersFilters?.[marker.category]?.[marker.status]) {
          this.numbersFilters[marker.category][marker.status]++
        } else {
          if (marker.category) {
            if (this.numbersFilters[marker.category]) {
              this.numbersFilters[marker.category][marker.status] = 1
            } else {
              this.numbersFilters[marker.category] = {
                [marker.status]: 1
              }
            }
          }
        }

        if (this.numbersCategories[marker.category]) {
          this.numbersCategories[marker.category]++
        } else {
          this.numbersCategories[marker.category] = 1
        }
      })
    },
    async fetchStatuses () {
      const statuses = await this.$store.dispatch('fetchAllStatuses', { apl_id: this.aplid })
      this.statuses = Object.freeze([...statuses])
      this.statuses.forEach(status => {
        this.filters.push(`${status.category_id.value} - ${status.value}`)

        if (this.numbersFilters[status.category_id.value]) {
          this.numbersFilters[status.category_id.value][status.value] = 0
        } else {
          this.numbersFilters[status.category_id.value] = {
            [status.value]: 0
          }
        }
      })
    },
    async fetchCategories () {
      const categories = await this.$store.dispatch('fetchAllCategories', { apl_id: this.aplid })
      this.categories = Object.freeze([...categories])
      this.categories.forEach(category => {
        this.categorii.push(category.value)
        this.numbersCategories[category.value] = 0
      })
    },

    getIcon (icon, type = 'icon') {
      const noFile = type === 'logo' ? '/logos/logo-tud-mic.png' : '/icons/apl-icon-orphan.png'
      return SERVER_URL + (icon && icon.url ? icon.url : noFile)
    },

    getPicURL (corp, index, picNo, preview = false) {
      if (preview) {
        return `${SERVER_URL}/temp/pre/${corp['#']}/${corp['#']}_C${index + 1}_${picNo}-40w.jpg`
      } else {
        return `${SERVER_URL}/temp/img/${corp['#']}/${corp['#']}_C${index + 1}_${picNo}.jpg`
      }
    },

    infoClosed () {
      this.infoOpen = false
      this.infoPosition = { lat: 0, lng: 0 }
      this.selectedMarker = null
    },
    markerClicked (marker) {
      this.infoPosition = { lat: marker.lat, lng: marker.lng }
      this.selectedMarker = marker
      this.infoOpen = true

      this.corpuri = tempItems.filter(corp => corp['#'] === marker.unique)

      this.corpuri.forEach((corp, index) => {
        this.corpHasPics(corp, index)
      })

      this.getDetails()
    },

    async getDetails () {
      // const details = await this.$store.dispatch('fetchDetails', this.selectedMarker._id)
      // const properties = await this.$store.dispatch('fetchProperties4Marker', this.selectedMarker)

      // console.log(details, properties)
    },

    async corpHasPics (corp, index) {
      const result = await this.$store.dispatch('fetchPics', { id: corp['#'], index: index + 1 })

      this.$set(corp, 'poze', result.length)
    }
  },

  async created () {
    await this.getAPL()
    await this.fetchStatuses()
    await this.fetchCategories()
    await this.fetchMarkers()
  },

  beforeDestroy () {
    this.$store.commit('setCurrentAPL', null)
  }
}

/* eslint-disable quote-props */
/* eslint-disable no-unused-vars */
const tempItems = [
  {
    '#': 'PS1',
    'ID APL': 'Sector 6',
    'Status': 'In asteptare',
    'Lat': 44.4409187808976,
    'Long': 26.0718380501586,
    'Unitatea de invatamant': 'Grd. M.ap.N. nr. 1',
    'Adresa obiectiv': 'Calea Plevnei, nr. 137B',
    'Tip unitate': 'UNITATI DE INVATAMANT PREUNIVERSITAR DE STAT',
    'Corp': 'in asteptare',
    'An constr.': null,
    'Regim inaltime': null,
    'Nr. Sali de clasa': null,
    'Economie de energie primara': null,
    'Procent energie din surse regenerabile': null,
    'Etapele procesului de reabilitare': null,
    'poze': 0
  },
  {
    '#': 'PS2',
    'ID APL': 'Sector 6',
    'Status': 'In asteptare',
    'Lat': 44.4508337688859,
    'Long': 26.046206551758,
    'Unitatea de invatamant': 'Grd. Fulg de Nea',
    'Adresa obiectiv': 'Sos. Ciurel, nr. 9-11',
    'Tip unitate': 'UNITATI DE INVATAMANT PREUNIVERSITAR DE STAT',
    'Corp': 'in asteptare',
    'An constr.': null,
    'Regim inaltime': null,
    'Nr. Sali de clasa': null,
    'Economie de energie primara': null,
    'Procent energie din surse regenerabile': null,
    'Etapele procesului de reabilitare': null,
    'poze': 0
  },
  {
    '#': 'PS3',
    'ID APL': 'Sector 6',
    'Status': 'In asteptare',
    'Lat': 44.4568919334248,
    'Long': 26.0502297858357,
    'Unitatea de invatamant': 'Grd. nr. 40',
    'Adresa obiectiv': 'Str.Tabla Butii nr. 60',
    'Tip unitate': 'UNITATI DE INVATAMANT PREUNIVERSITAR DE STAT',
    'Corp': 'in asteptare',
    'An constr.': null,
    'Regim inaltime': null,
    'Nr. Sali de clasa': null,
    'Economie de energie primara': null,
    'Procent energie din surse regenerabile': null,
    'Etapele procesului de reabilitare': null,
    'poze': 0
  },
  {
    '#': 'PS4',
    'ID APL': 'Sector 6',
    'Status': 'In asteptare',
    'Lat': 44.4172748429973,
    'Long': 26.0433540353868,
    'Unitatea de invatamant': 'Grd. nr. 41',
    'Adresa obiectiv': 'Str. Constantin Titel Petrescu nr. 12',
    'Tip unitate': 'UNITATI DE INVATAMANT PREUNIVERSITAR DE STAT',
    'Corp': 'in asteptare',
    'An constr.': null,
    'Regim inaltime': null,
    'Nr. Sali de clasa': null,
    'Economie de energie primara': null,
    'Procent energie din surse regenerabile': null,
    'Etapele procesului de reabilitare': null,
    'poze': 0
  },
  {
    '#': 'PS5',
    'ID APL': 'Sector 6',
    'Status': 'In asteptare',
    'Lat': 44.4257767717783,
    'Long': 26.0398559909093,
    'Unitatea de invatamant': 'Grd. Hillary Clinton',
    'Adresa obiectiv': 'Aleea Pravat nr. 16',
    'Tip unitate': 'UNITATI DE INVATAMANT PREUNIVERSITAR DE STAT',
    'Corp': 'in asteptare',
    'An constr.': null,
    'Regim inaltime': null,
    'Nr. Sali de clasa': null,
    'Economie de energie primara': null,
    'Procent energie din surse regenerabile': null,
    'Etapele procesului de reabilitare': null,
    'poze': 0
  },
  {
    '#': 'PS6',
    'ID APL': 'Sector 6',
    'Status': 'In asteptare',
    'Lat': 44.4167220216767,
    'Long': 26.0326021296357,
    'Unitatea de invatamant': 'Grd. Spiridusii',
    'Adresa obiectiv': 'Str. Valea Calugareasca nr. 6',
    'Tip unitate': 'UNITATI DE INVATAMANT PREUNIVERSITAR DE STAT',
    'Corp': 'in asteptare',
    'An constr.': null,
    'Regim inaltime': null,
    'Nr. Sali de clasa': null,
    'Economie de energie primara': null,
    'Procent energie din surse regenerabile': null,
    'Etapele procesului de reabilitare': null,
    'poze': 0
  },
  {
    '#': 'PS7',
    'ID APL': 'Sector 6',
    'Status': 'In asteptare',
    'Lat': 44.4213727643256,
    'Long': 26.0276788152714,
    'Unitatea de invatamant': 'Grd. nr. 94',
    'Adresa obiectiv': 'Str. Targu Neamt nr. 4',
    'Tip unitate': 'UNITATI DE INVATAMANT PREUNIVERSITAR DE STAT',
    'Corp': 'in asteptare',
    'An constr.': null,
    'Regim inaltime': null,
    'Nr. Sali de clasa': null,
    'Economie de energie primara': null,
    'Procent energie din surse regenerabile': null,
    'Etapele procesului de reabilitare': null,
    'poze': 0
  },
  {
    '#': 'PS8',
    'ID APL': 'Sector 6',
    'Status': 'In asteptare',
    'Lat': 44.4232396319017,
    'Long': 26.0464283563423,
    'Unitatea de invatamant': 'Grd. nr. 111',
    'Adresa obiectiv': 'Str. Sibiu nr. 8',
    'Tip unitate': 'UNITATI DE INVATAMANT PREUNIVERSITAR DE STAT',
    'Corp': 'in asteptare',
    'An constr.': null,
    'Regim inaltime': null,
    'Nr. Sali de clasa': null,
    'Economie de energie primara': null,
    'Procent energie din surse regenerabile': null,
    'Etapele procesului de reabilitare': null,
    'poze': 0
  },
  {
    '#': 'PS9',
    'ID APL': 'Sector 6',
    'Status': 'Reabilitate termic - in curs',
    'Lat': 44.4324684851733,
    'Long': 26.0269208644531,
    'Unitatea de invatamant': 'Grd. cu program prelungit Albinutele',
    'Adresa obiectiv': 'Str. Centurii nr. 4',
    'Tip unitate': 'UNITATI DE INVATAMANT PREUNIVERSITAR DE STAT',
    'Corp': 'in asteptare',
    'An constr.': null,
    'Regim inaltime': null,
    'Nr. Sali de clasa': null,
    'Economie de energie primara': null,
    'Procent energie din surse regenerabile': null,
    'Etapele procesului de reabilitare': null,
    'poze': 0
  },
  {
    '#': 'PS10',
    'ID APL': 'Sector 6',
    'Status': 'Reabilitate termic - in curs',
    'Lat': 44.4370902043985,
    'Long': 26.0370176060178,
    'Unitatea de invatamant': 'Grd. nr. 170',
    'Adresa obiectiv': 'Str. Fabricii nr. 22',
    'Tip unitate': 'UNITATI DE INVATAMANT PREUNIVERSITAR DE STAT',
    'Corp': 'in asteptare',
    'An constr.': null,
    'Regim inaltime': null,
    'Nr. Sali de clasa': null,
    'Economie de energie primara': null,
    'Procent energie din surse regenerabile': null,
    'Etapele procesului de reabilitare': null,
    'poze': 0
  },
  {
    '#': 'PS11',
    'ID APL': 'Sector 6',
    'Status': 'In asteptare',
    'Lat': 44.4327238989533,
    'Long': 26.0122224032498,
    'Unitatea de invatamant': 'Grd. Prichindel',
    'Adresa obiectiv': 'Bd. Iuliu Maniu nr. 73-75',
    'Tip unitate': 'UNITATI DE INVATAMANT PREUNIVERSITAR DE STAT',
    'Corp': 'in asteptare',
    'An constr.': null,
    'Regim inaltime': null,
    'Nr. Sali de clasa': null,
    'Economie de energie primara': null,
    'Procent energie din surse regenerabile': null,
    'Etapele procesului de reabilitare': null,
    'poze': 0
  },
  {
    '#': 'PS12',
    'ID APL': 'Sector 6',
    'Status': 'In asteptare',
    'Lat': 44.4367279516812,
    'Long': 26.0369022849466,
    'Unitatea de invatamant': 'Grd. Zana Florilor',
    'Adresa obiectiv': 'Str. Fabricii nr. 20',
    'Tip unitate': 'UNITATI DE INVATAMANT PREUNIVERSITAR DE STAT',
    'Corp': 'in asteptare',
    'An constr.': null,
    'Regim inaltime': null,
    'Nr. Sali de clasa': null,
    'Economie de energie primara': null,
    'Procent energie din surse regenerabile': null,
    'Etapele procesului de reabilitare': null,
    'poze': 0
  },
  {
    '#': 'PS13',
    'ID APL': 'Sector 6',
    'Status': 'In asteptare',
    'Lat': 44.4364653536965,
    'Long': 26.014866436369,
    'Unitatea de invatamant': 'Grd. Dumbrava Minunilor',
    'Adresa obiectiv': 'Str. Apusului nr. 71-73',
    'Tip unitate': 'UNITATI DE INVATAMANT PREUNIVERSITAR DE STAT',
    'Corp': 'in asteptare',
    'An constr.': null,
    'Regim inaltime': null,
    'Nr. Sali de clasa': null,
    'Economie de energie primara': null,
    'Procent energie din surse regenerabile': null,
    'Etapele procesului de reabilitare': null,
    'poze': 0
  },
  {
    '#': 'PS14',
    'ID APL': 'Sector 6',
    'Status': 'Reabilitate termic - in curs',
    'Lat': 44.4196644452183,
    'Long': 26.0142835437837,
    'Unitatea de invatamant': 'Grd. nr. 208',
    'Adresa obiectiv': 'Str. Valea Oltului nr. 14',
    'Tip unitate': 'UNITATI DE INVATAMANT PREUNIVERSITAR DE STAT',
    'Corp': 'in asteptare',
    'An constr.': null,
    'Regim inaltime': null,
    'Nr. Sali de clasa': null,
    'Economie de energie primara': null,
    'Procent energie din surse regenerabile': null,
    'Etapele procesului de reabilitare': null,
    'poze': 0
  },
  {
    '#': 'PS15',
    'ID APL': 'Sector 6',
    'Status': 'In asteptare',
    'Lat': 44.4194320660504,
    'Long': 26.0243266808358,
    'Unitatea de invatamant': 'Grd. nr. 209',
    'Adresa obiectiv': 'Str. Pascani nr. 15 bis',
    'Tip unitate': 'UNITATI DE INVATAMANT PREUNIVERSITAR DE STAT',
    'Corp': 'in asteptare',
    'An constr.': null,
    'Regim inaltime': null,
    'Nr. Sali de clasa': null,
    'Economie de energie primara': null,
    'Procent energie din surse regenerabile': null,
    'Etapele procesului de reabilitare': null,
    'poze': 0
  },
  {
    '#': 'PS16',
    'ID APL': 'Sector 6',
    'Status': 'In asteptare',
    'Lat': 44.4220163719616,
    'Long': 26.0166759889773,
    'Unitatea de invatamant': 'Grd. nr. 210',
    'Adresa obiectiv': 'Aleea Arinis nr. 1 bis',
    'Tip unitate': 'UNITATI DE INVATAMANT PREUNIVERSITAR DE STAT',
    'Corp': 'in asteptare',
    'An constr.': null,
    'Regim inaltime': null,
    'Nr. Sali de clasa': null,
    'Economie de energie primara': null,
    'Procent energie din surse regenerabile': null,
    'Etapele procesului de reabilitare': null,
    'poze': 0
  },
  {
    '#': 'PS17',
    'ID APL': 'Sector 6',
    'Status': 'Reabilitate termic - in curs',
    'Lat': 44.4242652273535,
    'Long': 26.032547021092,
    'Unitatea de invatamant': 'Grd. nr. 217',
    'Adresa obiectiv': 'Str. Brasov  nr. 20A',
    'Tip unitate': 'UNITATI DE INVATAMANT PREUNIVERSITAR DE STAT',
    'Corp': 'in asteptare',
    'An constr.': null,
    'Regim inaltime': null,
    'Nr. Sali de clasa': null,
    'Economie de energie primara': null,
    'Procent energie din surse regenerabile': null,
    'Etapele procesului de reabilitare': null,
    'poze': 0
  },
  {
    '#': 'PS18',
    'ID APL': 'Sector 6',
    'Status': 'In asteptare',
    'Lat': 44.4144475699754,
    'Long': 26.0158369742613,
    'Unitatea de invatamant': 'Grd. nr. 218',
    'Adresa obiectiv': 'Aleea Callatis nr. 5',
    'Tip unitate': 'UNITATI DE INVATAMANT PREUNIVERSITAR DE STAT',
    'Corp': 'in asteptare',
    'An constr.': null,
    'Regim inaltime': null,
    'Nr. Sali de clasa': null,
    'Economie de energie primara': null,
    'Procent energie din surse regenerabile': null,
    'Etapele procesului de reabilitare': null,
    'poze': 0
  },
  {
    '#': 'PS19',
    'ID APL': 'Sector 6',
    'Status': 'In asteptare',
    'Lat': 44.4236756023623,
    'Long': 26.0143035459081,
    'Unitatea de invatamant': 'Grd. nr. 229',
    'Adresa obiectiv': 'Aleea Dealul Macinului nr. 5',
    'Tip unitate': 'UNITATI DE INVATAMANT PREUNIVERSITAR DE STAT',
    'Corp': 'in asteptare',
    'An constr.': null,
    'Regim inaltime': null,
    'Nr. Sali de clasa': null,
    'Economie de energie primara': null,
    'Procent energie din surse regenerabile': null,
    'Etapele procesului de reabilitare': null,
    'poze': 0
  },
  {
    '#': 'PS20',
    'ID APL': 'Sector 6',
    'Status': 'Reabilitate termic - in curs',
    'Lat': 44.4143972534524,
    'Long': 26.0226705644187,
    'Unitatea de invatamant': 'Grd. nr. 230',
    'Adresa obiectiv': 'Aleea Potaisa nr. 3',
    'Tip unitate': 'UNITATI DE INVATAMANT PREUNIVERSITAR DE STAT',
    'Corp': 'in asteptare',
    'An constr.': null,
    'Regim inaltime': null,
    'Nr. Sali de clasa': null,
    'Economie de energie primara': null,
    'Procent energie din surse regenerabile': null,
    'Etapele procesului de reabilitare': null,
    'poze': 0
  },
  {
    '#': 'PS21',
    'ID APL': 'Sector 6',
    'Status': 'In asteptare',
    'Lat': 44.4369160609002,
    'Long': 26.0375961278044,
    'Unitatea de invatamant': 'Grd. nr .246',
    'Adresa obiectiv': 'Str. Fabricii nr. 20',
    'Tip unitate': 'UNITATI DE INVATAMANT PREUNIVERSITAR DE STAT',
    'Corp': 'in asteptare',
    'An constr.': null,
    'Regim inaltime': null,
    'Nr. Sali de clasa': null,
    'Economie de energie primara': null,
    'Procent energie din surse regenerabile': null,
    'Etapele procesului de reabilitare': null,
    'poze': 0
  },
  {
    '#': 'PS22',
    'ID APL': 'Sector 6',
    'Status': 'In asteptare',
    'Lat': 44.4381105949736,
    'Long': 26.0297799965774,
    'Unitatea de invatamant': 'Grd. nr. 250',
    'Adresa obiectiv': 'Str. Dealul Tugulea nr. 35',
    'Tip unitate': 'UNITATI DE INVATAMANT PREUNIVERSITAR DE STAT',
    'Corp': 'in asteptare',
    'An constr.': null,
    'Regim inaltime': null,
    'Nr. Sali de clasa': null,
    'Economie de energie primara': null,
    'Procent energie din surse regenerabile': null,
    'Etapele procesului de reabilitare': null,
    'poze': 0
  },
  {
    '#': 'PS23',
    'ID APL': 'Sector 6',
    'Status': 'In asteptare',
    'Lat': 44.4269687050432,
    'Long': 26.0397375285425,
    'Unitatea de invatamant': 'Grd. nr. 272',
    'Adresa obiectiv': 'Bd. Timisoara nr. 39',
    'Tip unitate': 'UNITATI DE INVATAMANT PREUNIVERSITAR DE STAT',
    'Corp': 'in asteptare',
    'An constr.': null,
    'Regim inaltime': null,
    'Nr. Sali de clasa': null,
    'Economie de energie primara': null,
    'Procent energie din surse regenerabile': null,
    'Etapele procesului de reabilitare': null,
    'poze': 0
  },
  {
    '#': 'PS24',
    'ID APL': 'Sector 6',
    'Status': 'In asteptare',
    'Lat': 44.414318106548,
    'Long': 26.0281053505771,
    'Unitatea de invatamant': 'Grd. nr. 273',
    'Adresa obiectiv': 'Str. Valea lui Mihai nr. 1',
    'Tip unitate': 'UNITATI DE INVATAMANT PREUNIVERSITAR DE STAT',
    'Corp': 'in asteptare',
    'An constr.': null,
    'Regim inaltime': null,
    'Nr. Sali de clasa': null,
    'Economie de energie primara': null,
    'Procent energie din surse regenerabile': null,
    'Etapele procesului de reabilitare': null,
    'poze': 0
  },
  {
    '#': 'PS25',
    'ID APL': 'Sector 6',
    'Status': 'Reabilitate termic - in curs',
    'Lat': 44.4330492833416,
    'Long': 26.0487415973573,
    'Unitatea de invatamant': 'Grd. nr. 274',
    'Adresa obiectiv': 'Bd. Iuliu Maniu nr. 11A',
    'Tip unitate': 'UNITATI DE INVATAMANT PREUNIVERSITAR DE STAT',
    'Corp': 'in asteptare',
    'An constr.': null,
    'Regim inaltime': null,
    'Nr. Sali de clasa': null,
    'Economie de energie primara': null,
    'Procent energie din surse regenerabile': null,
    'Etapele procesului de reabilitare': null,
    'poze': 0
  },
  {
    '#': 'PS26',
    'ID APL': 'Sector 6',
    'Status': 'Reabilitate termic - in curs',
    'Lat': 44.4312112308937,
    'Long': 26.0194145706205,
    'Unitatea de invatamant': 'Grd. Paradisul Piticilor',
    'Adresa obiectiv': 'Str. Moinesti nr. 9',
    'Tip unitate': 'UNITATI DE INVATAMANT PREUNIVERSITAR DE STAT',
    'Corp': 'in asteptare',
    'An constr.': null,
    'Regim inaltime': null,
    'Nr. Sali de clasa': null,
    'Economie de energie primara': null,
    'Procent energie din surse regenerabile': null,
    'Etapele procesului de reabilitare': null,
    'poze': 0
  },
  {
    '#': 'PS27',
    'ID APL': 'Sector 6',
    'Status': 'In asteptare',
    'Lat': 44.4177989204798,
    'Long': 26.0477225501949,
    'Unitatea de invatamant': 'Grd. Colt de Rai',
    'Adresa obiectiv': 'Str. Garleni nr. 10',
    'Tip unitate': 'UNITATI DE INVATAMANT PREUNIVERSITAR DE STAT',
    'Corp': 'in asteptare',
    'An constr.': null,
    'Regim inaltime': null,
    'Nr. Sali de clasa': null,
    'Economie de energie primara': null,
    'Procent energie din surse regenerabile': null,
    'Etapele procesului de reabilitare': null,
    'poze': 0
  },
  {
    '#': 'PS28',
    'ID APL': 'Sector 6',
    'Status': 'Reabilitate termic > 2015 - finalizat',
    'Lat': 44.4176862305882,
    'Long': 26.0447017590468,
    'Unitatea de invatamant': 'Scoala Gimnaziala nr. 59',
    'Adresa obiectiv': 'Str. Vladeasa nr. 9',
    'Tip unitate': 'UNITATI DE INVATAMANT PREUNIVERSITAR DE STAT',
    'Corp': 'scoala',
    'An constr.': 1982,
    'Regim inaltime': 'S+P+3E',
    'Nr. Sali de clasa': 33,
    'Economie de energie primara': 0.4964,
    'Procent energie din surse regenerabile': 0.3033,
    'Etapele procesului de reabilitare': '<strong>Intocmirea documentatiei tehnico-economice care presupune:</strong><ul><li>Expertiza tehnica;</li><li>Raport de audit energetic;</li><li>Documentatia de avizare a lucrarilor de inteventie;</li><li>Proiectul tehnic si detaliile de executie;</li><li>Certificatul de performanta energetica dupa efectuarea lucrarilor de interventie.</li></ul><strong>Executia lucrarilor de inteventie conform documentatiei tehnico-economice, care presupune:</strong><ul><li>Solutii pentru partea de constructii:</li><li>Termoizolarea suplimentara a peretilor exteriori;</li><li>Termoizolarea planseului peste ultimul nivel;</li><li>Termoizolarea planseului peste subsol;</li><li>Modernizarea ferestrelor prin inlocuirea tamplariei exterioare cu tamplarie performanta.</li></ul><strong>Solutii pe partea de instalatii: </strong><ul><li>Interventii conducte incalzire distributie subsol, sistem de ventilare mecanica cu recuperator de caldura, etc.</li></ul>',
    'poze': 0
  },
  {
    '#': 'PS28',
    'ID APL': 'Sector 6',
    'Status': 'In asteptare',
    'Lat': 44.4177937004852,
    'Long': 26.0442852755953,
    'Unitatea de invatamant': 'Scoala Gimnaziala nr. 59',
    'Adresa obiectiv': 'Str. Vladeasa nr. 9',
    'Tip unitate': 'UNITATI DE INVATAMANT PREUNIVERSITAR DE STAT',
    'Corp': 'sala de sport',
    'An constr.': null,
    'Regim inaltime': null,
    'Nr. Sali de clasa': null,
    'Economie de energie primara': null,
    'Procent energie din surse regenerabile': null,
    'Etapele procesului de reabilitare': null,
    'poze': 0
  },
  {
    '#': 'PS29',
    'ID APL': 'Sector 6',
    'Status': 'Reabilitate termic - in curs',
    'Lat': 44.4375357165098,
    'Long': 26.0371824552196,
    'Unitatea de invatamant': 'Scoala Gimnaziala nr. 117',
    'Adresa obiectiv': 'Str. Fabricii nr. 22',
    'Tip unitate': 'UNITATI DE INVATAMANT PREUNIVERSITAR DE STAT',
    'Corp': 'in asteptare',
    'An constr.': null,
    'Regim inaltime': null,
    'Nr. Sali de clasa': null,
    'Economie de energie primara': null,
    'Procent energie din surse regenerabile': null,
    'Etapele procesului de reabilitare': null,
    'poze': 0
  },
  {
    '#': 'PS30',
    'ID APL': 'Sector 6',
    'Status': 'In asteptare',
    'Lat': 44.4320433887521,
    'Long': 26.0264908365381,
    'Unitatea de invatamant': 'Scoala Gimnaziala nr. 142',
    'Adresa obiectiv': 'Str. Centurii nr. 4',
    'Tip unitate': 'UNITATI DE INVATAMANT PREUNIVERSITAR DE STAT',
    'Corp': 'in asteptare',
    'An constr.': null,
    'Regim inaltime': null,
    'Nr. Sali de clasa': null,
    'Economie de energie primara': null,
    'Procent energie din surse regenerabile': null,
    'Etapele procesului de reabilitare': null,
    'poze': 0
  },
  {
    '#': 'PS31',
    'ID APL': 'Sector 6',
    'Status': 'In asteptare',
    'Lat': 44.4716632393674,
    'Long': 26.0182097692806,
    'Unitatea de invatamant': 'Scoala Gimnaziala nr. 153',
    'Adresa obiectiv': 'Str. Drumul Sabareni nr. 21',
    'Tip unitate': 'UNITATI DE INVATAMANT PREUNIVERSITAR DE STAT',
    'Corp': 'in asteptare',
    'An constr.': null,
    'Regim inaltime': null,
    'Nr. Sali de clasa': null,
    'Economie de energie primara': null,
    'Procent energie din surse regenerabile': null,
    'Etapele procesului de reabilitare': null,
    'poze': 0
  },
  {
    '#': 'PS32',
    'ID APL': 'Sector 6',
    'Status': 'In asteptare',
    'Lat': 44.436978574946,
    'Long': 26.0289238605845,
    'Unitatea de invatamant': 'Scoala Gimnaziala nr. 156',
    'Adresa obiectiv': 'Str. Dealul Tugulea nr. 35',
    'Tip unitate': 'UNITATI DE INVATAMANT PREUNIVERSITAR DE STAT',
    'Corp': 'in asteptare',
    'An constr.': null,
    'Regim inaltime': null,
    'Nr. Sali de clasa': null,
    'Economie de energie primara': null,
    'Procent energie din surse regenerabile': null,
    'Etapele procesului de reabilitare': null,
    'poze': 0
  },
  {
    '#': 'PS33',
    'ID APL': 'Sector 6',
    'Status': 'Reabilitate termic - in curs',
    'Lat': 44.4322754924321,
    'Long': 26.0129463221676,
    'Unitatea de invatamant': 'Scoala Gimnaziala Ion Dumitriu',
    'Adresa obiectiv': 'Str. Hanul Ancutei nr. 4',
    'Tip unitate': 'UNITATI DE INVATAMANT PREUNIVERSITAR DE STAT',
    'Corp': 'in asteptare',
    'An constr.': null,
    'Regim inaltime': null,
    'Nr. Sali de clasa': null,
    'Economie de energie primara': null,
    'Procent energie din surse regenerabile': null,
    'Etapele procesului de reabilitare': null,
    'poze': 0
  },
  {
    '#': 'PS34',
    'ID APL': 'Sector 6',
    'Status': 'Reabilitate termic > 2015 - finalizat',
    'Lat': 44.4399058147356,
    'Long': 26.0131043000509,
    'Unitatea de invatamant': 'Scoala Gimnaziala Sfanta Treime',
    'Adresa obiectiv': 'Str. Ghirlandei nr. 7',
    'Tip unitate': 'UNITATI DE INVATAMANT PREUNIVERSITAR DE STAT',
    'Corp': 'in asteptare',
    'An constr.': null,
    'Regim inaltime': null,
    'Nr. Sali de clasa': null,
    'Economie de energie primara': null,
    'Procent energie din surse regenerabile': null,
    'Etapele procesului de reabilitare': null,
    'poze': 0
  },
  {
    '#': 'PS35',
    'ID APL': 'Sector 6',
    'Status': 'In asteptare',
    'Lat': 44.4709060373423,
    'Long': 26.0026553711029,
    'Unitatea de invatamant': 'Scoala Gimnaziala nr. 161',
    'Adresa obiectiv': 'Calea Giulesti nr. 486A',
    'Tip unitate': 'UNITATI DE INVATAMANT PREUNIVERSITAR DE STAT',
    'Corp': 'in asteptare',
    'An constr.': null,
    'Regim inaltime': null,
    'Nr. Sali de clasa': null,
    'Economie de energie primara': null,
    'Procent energie din surse regenerabile': null,
    'Etapele procesului de reabilitare': null,
    'poze': 0
  },
  {
    '#': 'PS36',
    'ID APL': 'Sector 6',
    'Status': 'Reabilitate termic - in curs',
    'Lat': 44.4619881607909,
    'Long': 26.0457591553291,
    'Unitatea de invatamant': 'Scoala Gimnaziala nr. 163',
    'Adresa obiectiv': 'Calea Giulesti nr. 54',
    'Tip unitate': 'UNITATI DE INVATAMANT PREUNIVERSITAR DE STAT',
    'Corp': 'in asteptare',
    'An constr.': null,
    'Regim inaltime': null,
    'Nr. Sali de clasa': null,
    'Economie de energie primara': null,
    'Procent energie din surse regenerabile': null,
    'Etapele procesului de reabilitare': null,
    'poze': 0
  },
  {
    '#': 'PS37',
    'ID APL': 'Sector 6',
    'Status': 'Reabilitate termic - in curs',
    'Lat': 44.4240207410889,
    'Long': 26.0382890132141,
    'Unitatea de invatamant': 'Scoala Gimnaziala nr. 164 (Sfantul Calinic de la Cernica)',
    'Adresa obiectiv': 'Str. Pravat nr. 22',
    'Tip unitate': 'UNITATI DE INVATAMANT PREUNIVERSITAR DE STAT',
    'Corp': 'in asteptare',
    'An constr.': null,
    'Regim inaltime': null,
    'Nr. Sali de clasa': null,
    'Economie de energie primara': null,
    'Procent energie din surse regenerabile': null,
    'Etapele procesului de reabilitare': null,
    'poze': 0
  },
  {
    '#': 'PS38',
    'ID APL': 'Sector 6',
    'Status': 'Reabilitate termic - in curs',
    'Lat': 44.4540364413892,
    'Long': 26.0400889454568,
    'Unitatea de invatamant': 'Scoala Gimnaziala nr. 167',
    'Adresa obiectiv': 'Calea Crangasi nr. 140',
    'Tip unitate': 'UNITATI DE INVATAMANT PREUNIVERSITAR DE STAT',
    'Corp': 'in asteptare',
    'An constr.': null,
    'Regim inaltime': null,
    'Nr. Sali de clasa': null,
    'Economie de energie primara': null,
    'Procent energie din surse regenerabile': null,
    'Etapele procesului de reabilitare': null,
    'poze': 0
  },
  {
    '#': 'PS39',
    'ID APL': 'Sector 6',
    'Status': 'Reabilitate termic - in curs',
    'Lat': 44.4512970645376,
    'Long': 26.057704951081,
    'Unitatea de invatamant': 'Scoala Gimnaziala nr. 168',
    'Adresa obiectiv': 'Str. Alizeului nr. 9',
    'Tip unitate': 'UNITATI DE INVATAMANT PREUNIVERSITAR DE STAT',
    'Corp': 'in asteptare',
    'An constr.': null,
    'Regim inaltime': null,
    'Nr. Sali de clasa': null,
    'Economie de energie primara': null,
    'Procent energie din surse regenerabile': null,
    'Etapele procesului de reabilitare': null,
    'poze': 0
  },
  {
    '#': 'PS40',
    'ID APL': 'Sector 6',
    'Status': 'In asteptare',
    'Lat': 44.4214523780727,
    'Long': 26.0249796461937,
    'Unitatea de invatamant': 'Scoala Gimnaziala nr. 169',
    'Adresa obiectiv': 'Str. Pascani nr. 2',
    'Tip unitate': 'UNITATI DE INVATAMANT PREUNIVERSITAR DE STAT',
    'Corp': 'in asteptare',
    'An constr.': null,
    'Regim inaltime': null,
    'Nr. Sali de clasa': null,
    'Economie de energie primara': null,
    'Procent energie din surse regenerabile': null,
    'Etapele procesului de reabilitare': null,
    'poze': 0
  },
  {
    '#': 'PS41',
    'ID APL': 'Sector 6',
    'Status': 'Reabilitate termic > 2015 - finalizat',
    'Lat': 44.4183262972964,
    'Long': 26.0163074969927,
    'Unitatea de invatamant': 'Scoala Gimnaziala Sfantul Andrei',
    'Adresa obiectiv': 'Aleea Parva nr. 3-5',
    'Tip unitate': 'UNITATI DE INVATAMANT PREUNIVERSITAR DE STAT',
    'Corp': 'scoala (corp A)',
    'An constr.': 1973,
    'Regim inaltime': 'S+P+2E',
    'Nr. Sali de clasa': 31,
    'Economie de energie primara': 0.5401,
    'Procent energie din surse regenerabile': 0.3359,
    'Etapele procesului de reabilitare': '<strong>Intocmirea documentatiei tehnico-economice care presupune:</strong><ul><li>Expertiza tehnica;</li><li>Raport de audit energetic;</li><li>Documentatia de avizare a lucrarilor de inteventie;</li><li>Proiectul tehnic si detaliile de executie;</li><li>Certificatul de performanta energetica dupa efectuarea lucrarilor de interventie.</li></ul><strong>Executia lucrarilor de inteventie conform documentatiei tehnico-economice, care presupune:</strong><ul><li>Solutii pentru partea de constructii:</li><li>Termoizolarea suplimentara a peretilor exteriori;</li><li>Termoizolarea planseului peste ultimul nivel;</li><li>Termoizolarea planseului peste subsol;</li><li>Modernizarea ferestrelor prin inlocuirea tamplariei exterioare cu tamplarie performanta.</li></ul><strong>Solutii pe partea de instalatii: </strong><ul><li>Interventii conducte incalzire distributie subsol, sistem de ventilare mecanica cu recuperator de caldura, etc.</li></ul>',
    'poze': 0
  },
  {
    '#': 'PS41',
    'ID APL': 'Sector 6',
    'Status': 'Reabilitate termic > 2015 - finalizat',
    'Lat': 44.4187702953192,
    'Long': 26.0162134413129,
    'Unitatea de invatamant': 'Scoala Gimnaziala Sfantul Andrei',
    'Adresa obiectiv': 'Aleea Parva nr. 3-5',
    'Tip unitate': 'UNITATI DE INVATAMANT PREUNIVERSITAR DE STAT',
    'Corp': 'scoala (corp B)',
    'An constr.': 1985,
    'Regim inaltime': 'Sp+P+3E',
    'Nr. Sali de clasa': 19,
    'Economie de energie primara': 0.4533,
    'Procent energie din surse regenerabile': 0.3041,
    'Etapele procesului de reabilitare': '<strong>Intocmirea documentatiei tehnico-economice care presupune:</strong><ul><li>Expertiza tehnica;</li><li>Raport de audit energetic;</li><li>Documentatia de avizare a lucrarilor de inteventie;</li><li>Proiectul tehnic si detaliile de executie;</li><li>Certificatul de performanta energetica dupa efectuarea lucrarilor de interventie.</li></ul><strong>Executia lucrarilor de inteventie conform documentatiei tehnico-economice, care presupune:</strong><ul><li>Solutii pentru partea de constructii:</li><li>Termoizolarea suplimentara a peretilor exteriori;</li><li>Termoizolarea planseului peste ultimul nivel;</li><li>Termoizolarea planseului peste subsol;</li><li>Modernizarea ferestrelor prin inlocuirea tamplariei exterioare cu tamplarie performanta.</li></ul><strong>Solutii pe partea de instalatii: </strong><ul><li>Interventii conducte incalzire distributie subsol, sistem de ventilare mecanica cu recuperator de caldura, etc.</li></ul>',
    'poze': 0
  },
  {
    '#': 'PS41',
    'ID APL': 'Sector 6',
    'Status': 'In asteptare',
    'Lat': 44.418832404809,
    'Long': 26.015459583094,
    'Unitatea de invatamant': 'Scoala Gimnaziala Sfantul Andrei',
    'Adresa obiectiv': 'Aleea Parva nr. 3-5',
    'Tip unitate': 'UNITATI DE INVATAMANT PREUNIVERSITAR DE STAT',
    'Corp': 'sala de sport',
    'An constr.': null,
    'Regim inaltime': null,
    'Nr. Sali de clasa': null,
    'Economie de energie primara': null,
    'Procent energie din surse regenerabile': null,
    'Etapele procesului de reabilitare': null,
    'poze': 0
  },
  {
    '#': 'PS42',
    'ID APL': 'Sector 6',
    'Status': 'In asteptare',
    'Lat': 44.4375584397111,
    'Long': 26.0222880224432,
    'Unitatea de invatamant': 'Scoala Gimnaziala Constantin Brancusi',
    'Adresa obiectiv': 'Str. Rosia Montana nr. 41',
    'Tip unitate': 'UNITATI DE INVATAMANT PREUNIVERSITAR DE STAT',
    'Corp': 'in asteptare',
    'An constr.': null,
    'Regim inaltime': null,
    'Nr. Sali de clasa': null,
    'Economie de energie primara': null,
    'Procent energie din surse regenerabile': null,
    'Etapele procesului de reabilitare': null,
    'poze': 0
  },
  {
    '#': 'PS43',
    'ID APL': 'Sector 6',
    'Status': 'Reabilitate termic > 2015 - finalizat',
    'Lat': 44.4246507719816,
    'Long': 26.0208542846817,
    'Unitatea de invatamant': 'Scoala Gimnaziala Sfintii Constantin si Elena',
    'Adresa obiectiv': 'Aleea Lunca Cernei nr. 3',
    'Tip unitate': 'UNITATI DE INVATAMANT PREUNIVERSITAR DE STAT',
    'Corp': 'scoala',
    'An constr.': 1974,
    'Regim inaltime': 'S+P+2E',
    'Nr. Sali de clasa': 25,
    'Economie de energie primara': 0.5493,
    'Procent energie din surse regenerabile': 0.3284,
    'Etapele procesului de reabilitare': '<strong>Intocmirea documentatiei tehnico-economice care presupune:</strong><ul><li>Expertiza tehnica;</li><li>Raport de audit energetic;</li><li>Documentatia de avizare a lucrarilor de inteventie;</li><li>Proiectul tehnic si detaliile de executie;</li><li>Certificatul de performanta energetica dupa efectuarea lucrarilor de interventie.</li></ul><strong>Executia lucrarilor de inteventie conform documentatiei tehnico-economice, care presupune:</strong><ul><li>Solutii pentru partea de constructii:</li><li>Termoizolarea suplimentara a peretilor exteriori;</li><li>Termoizolarea planseului peste ultimul nivel;</li><li>Termoizolarea planseului peste subsol;</li><li>Modernizarea ferestrelor prin inlocuirea tamplariei exterioare cu tamplarie performanta.</li></ul><strong>Solutii pe partea de instalatii: </strong><ul><li>Interventii conducte incalzire distributie subsol, sistem de ventilare mecanica cu recuperator de caldura, etc.</li></ul>',
    'poze': 0
  },
  {
    '#': 'PS44',
    'ID APL': 'Sector 6',
    'Status': 'In asteptare',
    'Lat': 44.4265315279408,
    'Long': 26.0517521682335,
    'Unitatea de invatamant': 'Scoala Gimnaziala Orizont (193)',
    'Adresa obiectiv': 'Str. Mihaela Ruxandra Marcu nr. 3',
    'Tip unitate': 'UNITATI DE INVATAMANT PREUNIVERSITAR DE STAT',
    'Corp': 'in asteptare',
    'An constr.': null,
    'Regim inaltime': null,
    'Nr. Sali de clasa': null,
    'Economie de energie primara': null,
    'Procent energie din surse regenerabile': null,
    'Etapele procesului de reabilitare': null,
    'poze': 0
  },
  {
    '#': 'PS45',
    'ID APL': 'Sector 6',
    'Status': 'Reabilitate termic > 2015 - finalizat',
    'Lat': 44.4220887221239,
    'Long': 26.0429966296442,
    'Unitatea de invatamant': 'Scoala Gimnaziala nr. 197',
    'Adresa obiectiv': 'Str. Obcina Mare nr. 2',
    'Tip unitate': 'UNITATI DE INVATAMANT PREUNIVERSITAR DE STAT',
    'Corp': 'scoala',
    'An constr.': 1967,
    'Regim inaltime': 'Sp+P+2E',
    'Nr. Sali de clasa': 47,
    'Economie de energie primara': 0.5148,
    'Procent energie din surse regenerabile': 0.3443,
    'Etapele procesului de reabilitare': '<strong>Intocmirea documentatiei tehnico-economice care presupune:</strong><ul><li>Expertiza tehnica;</li><li>Raport de audit energetic;</li><li>Documentatia de avizare a lucrarilor de inteventie;</li><li>Proiectul tehnic si detaliile de executie;</li><li>Certificatul de performanta energetica dupa efectuarea lucrarilor de interventie.</li></ul><strong>Executia lucrarilor de inteventie conform documentatiei tehnico-economice, care presupune:</strong><ul><li>Solutii pentru partea de constructii:</li><li>Termoizolarea suplimentara a peretilor exteriori;</li><li>Termoizolarea planseului peste ultimul nivel;</li><li>Termoizolarea planseului peste subsol;</li><li>Modernizarea ferestrelor prin inlocuirea tamplariei exterioare cu tamplarie performanta.</li></ul><strong>Solutii pe partea de instalatii: </strong><ul><li>Interventii conducte incalzire distributie subsol, sistem de ventilare mecanica cu recuperator de caldura, etc.</li></ul>',
    'poze': 0
  },
  {
    '#': 'PS46',
    'ID APL': 'Sector 6',
    'Status': 'Reabilitate termic > 2015 - finalizat',
    'Lat': 44.4365760849885,
    'Long': 26.0144276751166,
    'Unitatea de invatamant': 'Scoala Gimnaziala Regina Maria (198)',
    'Adresa obiectiv': 'Str. Apusului nr. 71-73',
    'Tip unitate': 'UNITATI DE INVATAMANT PREUNIVERSITAR DE STAT',
    'Corp': 'in asteptare',
    'An constr.': null,
    'Regim inaltime': null,
    'Nr. Sali de clasa': null,
    'Economie de energie primara': null,
    'Procent energie din surse regenerabile': null,
    'Etapele procesului de reabilitare': null,
    'poze': 0
  },
  {
    '#': 'PS47',
    'ID APL': 'Sector 6',
    'Status': 'Reabilitate termic > 2015 - finalizat',
    'Lat': 44.4190830598728,
    'Long': 26.0380622362519,
    'Unitatea de invatamant': 'Scoala Gimnaziala Adrian Paunescu',
    'Adresa obiectiv': 'Aleea Valea Prahovei nr. 1',
    'Tip unitate': 'UNITATI DE INVATAMANT PREUNIVERSITAR DE STAT',
    'Corp': 'scoala',
    'An constr.': 1968,
    'Regim inaltime': 'S+P+2E',
    'Nr. Sali de clasa': 27,
    'Economie de energie primara': 0.5833,
    'Procent energie din surse regenerabile': 0.3964,
    'Etapele procesului de reabilitare': '<strong>Intocmirea documentatiei tehnico-economice care presupune:</strong><ul><li>Expertiza tehnica;</li><li>Raport de audit energetic;</li><li>Documentatia de avizare a lucrarilor de inteventie;</li><li>Proiectul tehnic si detaliile de executie;</li><li>Certificatul de performanta energetica dupa efectuarea lucrarilor de interventie.</li></ul><strong>Executia lucrarilor de inteventie conform documentatiei tehnico-economice, care presupune:</strong><ul><li>Solutii pentru partea de constructii:</li><li>Termoizolarea suplimentara a peretilor exteriori;</li><li>Termoizolarea planseului peste ultimul nivel;</li><li>Termoizolarea planseului peste subsol;</li><li>Modernizarea ferestrelor prin inlocuirea tamplariei exterioare cu tamplarie performanta.</li></ul><strong>Solutii pe partea de instalatii: </strong><ul><li>Interventii conducte incalzire distributie subsol, sistem de ventilare mecanica cu recuperator de caldura, etc.</li></ul>',
    'poze': 0
  },
  {
    '#': 'PS47',
    'ID APL': 'Sector 6',
    'Status': 'In asteptare',
    'Lat': 44.4186936511336,
    'Long': 26.0374934964812,
    'Unitatea de invatamant': 'Scoala Gimnaziala Adrian Paunescu',
    'Adresa obiectiv': 'Aleea Valea Prahovei nr. 1',
    'Tip unitate': 'UNITATI DE INVATAMANT PREUNIVERSITAR DE STAT',
    'Corp': 'sala de sport',
    'An constr.': null,
    'Regim inaltime': null,
    'Nr. Sali de clasa': null,
    'Economie de energie primara': null,
    'Procent energie din surse regenerabile': null,
    'Etapele procesului de reabilitare': null,
    'poze': 0
  },
  {
    '#': 'PS48',
    'ID APL': 'Sector 6',
    'Status': 'In asteptare',
    'Lat': 44.4229904760807,
    'Long': 26.0166924672928,
    'Unitatea de invatamant': 'Scoala Gimnaziala nr. 206',
    'Adresa obiectiv': 'Aleea Arinis nr. 5',
    'Tip unitate': 'UNITATI DE INVATAMANT PREUNIVERSITAR DE STAT',
    'Corp': 'in asteptare',
    'An constr.': null,
    'Regim inaltime': null,
    'Nr. Sali de clasa': null,
    'Economie de energie primara': null,
    'Procent energie din surse regenerabile': null,
    'Etapele procesului de reabilitare': null,
    'poze': 0
  },
  {
    '#': 'PS49',
    'ID APL': 'Sector 6',
    'Status': 'In asteptare',
    'Lat': 44.4131512823217,
    'Long': 26.0236713317807,
    'Unitatea de invatamant': 'Scoala Gimnaziala nr. 279',
    'Adresa obiectiv': 'Str. Prelungirea Ghencea nr. 24',
    'Tip unitate': 'UNITATI DE INVATAMANT PREUNIVERSITAR DE STAT',
    'Corp': 'in asteptare',
    'An constr.': null,
    'Regim inaltime': null,
    'Nr. Sali de clasa': null,
    'Economie de energie primara': null,
    'Procent energie din surse regenerabile': null,
    'Etapele procesului de reabilitare': null,
    'poze': 0
  },
  {
    '#': 'PS50',
    'ID APL': 'Sector 6',
    'Status': 'Reabilitate termic - in curs',
    'Lat': 44.4315860186358,
    'Long': 26.0191451649397,
    'Unitatea de invatamant': 'Scoala Gimnaziala nr. 309',
    'Adresa obiectiv': 'Str. Moinesti nr. 9',
    'Tip unitate': 'UNITATI DE INVATAMANT PREUNIVERSITAR DE STAT',
    'Corp': 'in asteptare',
    'An constr.': null,
    'Regim inaltime': null,
    'Nr. Sali de clasa': null,
    'Economie de energie primara': null,
    'Procent energie din surse regenerabile': null,
    'Etapele procesului de reabilitare': null,
    'poze': 0
  },
  {
    '#': 'PS51',
    'ID APL': 'Sector 6',
    'Status': 'In asteptare',
    'Lat': 44.4385729355196,
    'Long': 26.0233630251372,
    'Unitatea de invatamant': 'Scoala Gimnaziala Regele Mihai I',
    'Adresa obiectiv': 'Str. Dezrobirii nr. 41',
    'Tip unitate': 'UNITATI DE INVATAMANT PREUNIVERSITAR DE STAT',
    'Corp': 'in asteptare',
    'An constr.': null,
    'Regim inaltime': null,
    'Nr. Sali de clasa': null,
    'Economie de energie primara': null,
    'Procent energie din surse regenerabile': null,
    'Etapele procesului de reabilitare': null,
    'poze': 0
  },
  {
    '#': 'PS52',
    'ID APL': 'Sector 6',
    'Status': 'In asteptare',
    'Lat': 44.4176331235647,
    'Long': 26.0468773730564,
    'Unitatea de invatamant': 'Scoala Gimnaziala nr. 311',
    'Adresa obiectiv': 'Str. Garleni nr. 10',
    'Tip unitate': 'UNITATI DE INVATAMANT PREUNIVERSITAR DE STAT',
    'Corp': 'in asteptare',
    'An constr.': null,
    'Regim inaltime': null,
    'Nr. Sali de clasa': null,
    'Economie de energie primara': null,
    'Procent energie din surse regenerabile': null,
    'Etapele procesului de reabilitare': null,
    'poze': 0
  },
  {
    '#': 'PS53',
    'ID APL': 'Sector 6',
    'Status': 'Reabilitate termic - in curs',
    'Lat': 44.4135745022381,
    'Long': 26.0177856462738,
    'Unitatea de invatamant': 'Scoala Gimnaziala Speciala Constantin Paunescu',
    'Adresa obiectiv': 'Aleea Istru nr. 4',
    'Tip unitate': 'UNITATI DE INVATAMANT PREUNIVERSITAR DE STAT',
    'Corp': 'in asteptare',
    'An constr.': null,
    'Regim inaltime': null,
    'Nr. Sali de clasa': null,
    'Economie de energie primara': null,
    'Procent energie din surse regenerabile': null,
    'Etapele procesului de reabilitare': null,
    'poze': 0
  },
  {
    '#': 'PS54',
    'ID APL': 'Sector 6',
    'Status': 'Reabilitate termic - in curs',
    'Lat': 44.4134549497863,
    'Long': 26.0159989231215,
    'Unitatea de invatamant': 'Scoala Gimnaziala Speciala pentru Deficienti de Auz Sfanta Maria',
    'Adresa obiectiv': 'Aleea Istru nr. 6',
    'Tip unitate': 'UNITATI DE INVATAMANT PREUNIVERSITAR DE STAT',
    'Corp': 'in asteptare',
    'An constr.': null,
    'Regim inaltime': null,
    'Nr. Sali de clasa': null,
    'Economie de energie primara': null,
    'Procent energie din surse regenerabile': null,
    'Etapele procesului de reabilitare': null,
    'poze': 0
  },
  {
    '#': 'PS55',
    'ID APL': 'Sector 6',
    'Status': 'Reabilitate termic - in curs',
    'Lat': 44.4359119449546,
    'Long': 26.0316796643228,
    'Unitatea de invatamant': 'Colegiul Economic Costin C. Kiritescu',
    'Adresa obiectiv': 'Str. Pestera Dambovicioarei nr. 12',
    'Tip unitate': 'UNITATI DE INVATAMANT PREUNIVERSITAR DE STAT',
    'Corp': 'in asteptare',
    'An constr.': null,
    'Regim inaltime': null,
    'Nr. Sali de clasa': null,
    'Economie de energie primara': null,
    'Procent energie din surse regenerabile': null,
    'Etapele procesului de reabilitare': null,
    'poze': 0
  },
  {
    '#': 'PS56',
    'ID APL': 'Sector 6',
    'Status': 'In asteptare',
    'Lat': 44.4175154804712,
    'Long': 26.0248087165897,
    'Unitatea de invatamant': 'Colegiul National Elena Cuza',
    'Adresa obiectiv': 'Str. Pestera Scarisoara nr. 1',
    'Tip unitate': 'UNITATI DE INVATAMANT PREUNIVERSITAR DE STAT',
    'Corp': 'in asteptare',
    'An constr.': null,
    'Regim inaltime': null,
    'Nr. Sali de clasa': null,
    'Economie de energie primara': null,
    'Procent energie din surse regenerabile': null,
    'Etapele procesului de reabilitare': null,
    'poze': 0
  },
  {
    '#': 'PS57',
    'ID APL': 'Sector 6',
    'Status': 'In asteptare',
    'Lat': 44.4265797640128,
    'Long': 26.0411940530341,
    'Unitatea de invatamant': 'Colegiul National Grigore Moisil',
    'Adresa obiectiv': 'Bd. Timisoara nr. 33',
    'Tip unitate': 'UNITATI DE INVATAMANT PREUNIVERSITAR DE STAT',
    'Corp': 'in asteptare',
    'An constr.': null,
    'Regim inaltime': null,
    'Nr. Sali de clasa': null,
    'Economie de energie primara': null,
    'Procent energie din surse regenerabile': null,
    'Etapele procesului de reabilitare': null,
    'poze': 0
  },
  {
    '#': 'PS58',
    'ID APL': 'Sector 6',
    'Status': 'In asteptare',
    'Lat': 44.4565440609396,
    'Long': 26.0514697174777,
    'Unitatea de invatamant': 'Colegiul Tehnic Carol I',
    'Adresa obiectiv': 'Str. Porumbacu nr. 52',
    'Tip unitate': 'UNITATI DE INVATAMANT PREUNIVERSITAR DE STAT',
    'Corp': 'in asteptare',
    'An constr.': null,
    'Regim inaltime': null,
    'Nr. Sali de clasa': null,
    'Economie de energie primara': null,
    'Procent energie din surse regenerabile': null,
    'Etapele procesului de reabilitare': null,
    'poze': 0
  },
  {
    '#': 'PS59',
    'ID APL': 'Sector 6',
    'Status': 'In asteptare',
    'Lat': 44.4248032075148,
    'Long': 26.0244285824542,
    'Unitatea de invatamant': 'Colegiul Tehnic de Posta si Telecomunicatii Gheorghe Airinei',
    'Adresa obiectiv': 'Str. Romancierilor nr. 1',
    'Tip unitate': 'UNITATI DE INVATAMANT PREUNIVERSITAR DE STAT',
    'Corp': 'in asteptare',
    'An constr.': null,
    'Regim inaltime': null,
    'Nr. Sali de clasa': null,
    'Economie de energie primara': null,
    'Procent energie din surse regenerabile': null,
    'Etapele procesului de reabilitare': null,
    'poze': 0
  },
  {
    '#': 'PS60',
    'ID APL': 'Sector 6',
    'Status': 'Reabilitate termic - in curs',
    'Lat': 44.4250969418063,
    'Long': 26.0369038148146,
    'Unitatea de invatamant': 'Colegiul Tehnic Gheorghe Asachi',
    'Adresa obiectiv': 'Aleea Pravat nr. 24',
    'Tip unitate': 'UNITATI DE INVATAMANT PREUNIVERSITAR DE STAT',
    'Corp': 'in asteptare',
    'An constr.': null,
    'Regim inaltime': null,
    'Nr. Sali de clasa': null,
    'Economie de energie primara': null,
    'Procent energie din surse regenerabile': null,
    'Etapele procesului de reabilitare': null,
    'poze': 0
  },
  {
    '#': 'PS61',
    'ID APL': 'Sector 6',
    'Status': 'In asteptare',
    'Lat': 44.4347480703613,
    'Long': 25.9753591642667,
    'Unitatea de invatamant': 'Colegiul Tehnic Iuliu Maniu',
    'Adresa obiectiv': 'Bd. Iuliu Maniu nr. 381-391',
    'Tip unitate': 'UNITATI DE INVATAMANT PREUNIVERSITAR DE STAT',
    'Corp': 'in asteptare',
    'An constr.': null,
    'Regim inaltime': null,
    'Nr. Sali de clasa': null,
    'Economie de energie primara': null,
    'Procent energie din surse regenerabile': null,
    'Etapele procesului de reabilitare': null,
    'poze': 0
  },
  {
    '#': 'PS62',
    'ID APL': 'Sector 6',
    'Status': 'Reabilitate termic - in curs',
    'Lat': 44.4288883129463,
    'Long': 26.0507477783963,
    'Unitatea de invatamant': 'Colegiul Tehnic Petru Maior',
    'Adresa obiectiv': 'Bd. Timisoara nr. 6',
    'Tip unitate': 'UNITATI DE INVATAMANT PREUNIVERSITAR DE STAT',
    'Corp': 'in asteptare',
    'An constr.': null,
    'Regim inaltime': null,
    'Nr. Sali de clasa': null,
    'Economie de energie primara': null,
    'Procent energie din surse regenerabile': null,
    'Etapele procesului de reabilitare': null,
    'poze': 0
  },
  {
    '#': 'PS63',
    'ID APL': 'Sector 6',
    'Status': 'In asteptare',
    'Lat': 44.4445728386849,
    'Long': 26.0500492668326,
    'Unitatea de invatamant': 'Liceul cu Program Sportiv Mircea Eliade',
    'Adresa obiectiv': 'Splaiul Independentei nr. 315-317',
    'Tip unitate': 'UNITATI DE INVATAMANT PREUNIVERSITAR DE STAT',
    'Corp': 'in asteptare',
    'An constr.': null,
    'Regim inaltime': null,
    'Nr. Sali de clasa': null,
    'Economie de energie primara': null,
    'Procent energie din surse regenerabile': null,
    'Etapele procesului de reabilitare': null,
    'poze': 0
  },
  {
    '#': 'PS64',
    'ID APL': 'Sector 6',
    'Status': 'Reabilitate termic - in curs',
    'Lat': 44.4326170116797,
    'Long': 25.9902165199928,
    'Unitatea de invatamant': 'Liceul Tehnologic Petru Poni',
    'Adresa obiectiv': 'Bd. Preciziei nr. 18',
    'Tip unitate': 'UNITATI DE INVATAMANT PREUNIVERSITAR DE STAT',
    'Corp': 'in asteptare',
    'An constr.': null,
    'Regim inaltime': null,
    'Nr. Sali de clasa': null,
    'Economie de energie primara': null,
    'Procent energie din surse regenerabile': null,
    'Etapele procesului de reabilitare': null,
    'poze': 0
  },
  {
    '#': 'PS65',
    'ID APL': 'Sector 6',
    'Status': 'In asteptare',
    'Lat': 44.4245056680551,
    'Long': 26.0288468776584,
    'Unitatea de invatamant': 'Liceul Tehnologic Sfantul Antim Ivireanu',
    'Adresa obiectiv': 'Aleea Poiana Muntelui nr. 1',
    'Tip unitate': 'UNITATI DE INVATAMANT PREUNIVERSITAR DE STAT',
    'Corp': 'in asteptare',
    'An constr.': null,
    'Regim inaltime': null,
    'Nr. Sali de clasa': null,
    'Economie de energie primara': null,
    'Procent energie din surse regenerabile': null,
    'Etapele procesului de reabilitare': null,
    'poze': 0
  },
  {
    '#': 'PS66',
    'ID APL': 'Sector 6',
    'Status': 'In asteptare',
    'Lat': 44.4155404407937,
    'Long': 26.0281534233953,
    'Unitatea de invatamant': 'Liceul Teoretic Eugen Lovinescu',
    'Adresa obiectiv': 'Str. Valea lui Mihai nr. 6',
    'Tip unitate': 'UNITATI DE INVATAMANT PREUNIVERSITAR DE STAT',
    'Corp': 'in asteptare',
    'An constr.': null,
    'Regim inaltime': null,
    'Nr. Sali de clasa': null,
    'Economie de energie primara': null,
    'Procent energie din surse regenerabile': null,
    'Etapele procesului de reabilitare': null,
    'poze': 0
  },
  {
    '#': 'PS67',
    'ID APL': 'Sector 6',
    'Status': 'In asteptare',
    'Lat': 44.4596123915052,
    'Long': 26.0428418918419,
    'Unitatea de invatamant': 'Liceul Teoretic Marin Preda',
    'Adresa obiectiv': 'Str. Rusetu nr. 17',
    'Tip unitate': 'UNITATI DE INVATAMANT PREUNIVERSITAR DE STAT',
    'Corp': 'in asteptare',
    'An constr.': null,
    'Regim inaltime': null,
    'Nr. Sali de clasa': null,
    'Economie de energie primara': null,
    'Procent energie din surse regenerabile': null,
    'Etapele procesului de reabilitare': null,
    'poze': 0
  },
  {
    '#': 'PS68',
    'ID APL': 'Sector 6',
    'Status': 'In asteptare',
    'Lat': 44.4337785391613,
    'Long': 26.0426345586934,
    'Unitatea de invatamant': 'Liceul Teoretic Tudor Vladimirescu',
    'Adresa obiectiv': 'Bd. Iuliu Maniu nr. 15',
    'Tip unitate': 'UNITATI DE INVATAMANT PREUNIVERSITAR DE STAT',
    'Corp': 'in asteptare',
    'An constr.': null,
    'Regim inaltime': null,
    'Nr. Sali de clasa': null,
    'Economie de energie primara': null,
    'Procent energie din surse regenerabile': null,
    'Etapele procesului de reabilitare': null,
    'poze': 0
  }
]
</script>
